import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["placeholder", "onUpdate:modelValue", "onBlur"]
const _hoisted_2 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_3 = ["title", "onClick"]
const _hoisted_4 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_5 = {
  key: 1,
  class: "invalid-feedback"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, key) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "input-group mb-3",
        key: key
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: _normalizeClass(["form-control flex-grow-0 w-25", {'is-invalid': _ctx.numberInvalid(row) || _ctx.noteWithoutNumber(row)}]),
          placeholder: _ctx.$t('form.parcelNumbers.placeholder'),
          "onUpdate:modelValue": ($event: any) => ((row.number) = $event),
          onBlur: ($event: any) => (_ctx.normalizeLine(key))
        }, null, 42, _hoisted_1), [
          [_vModelText, row.number]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          placeholder: _ctx.$t('form.parcelNumbers.notePlaceholder'),
          "onUpdate:modelValue": ($event: any) => ((row.note) = $event)
        }, null, 8, _hoisted_2), [
          [_vModelText, row.note]
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline-secondary",
          title: _ctx.$t('form.buttonRemove'),
          onClick: ($event: any) => (_ctx.removeLine(key))
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("span", { class: "fas fa-times" }, null, -1)
        ]))], 8, _hoisted_3),
        (_ctx.numberInvalid(row))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('form.errors.invalidParcelNumber')), 1))
          : (_ctx.noteWithoutNumber(row))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('form.errors.missingParcelNumber')), 1))
            : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-outline-primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addLine()))
    }, _toDisplayString(_ctx.$t('form.parcelNumbers.buttonAdd')), 1)
  ]))
}